<template>
  <div :class="[rootClass, `${rootClass}--color-${color}`]">
    <i v-if="icon" :class="[`${rootClass}__icon`, `fa fa-${icon}`]"></i>
    <select
      :id="id"
      class="form-select"
      @input="emitInput"
    >
      <option :selected="value === ''" hidden>{{ placeholder }}</option>
      <option
        v-for="({ key, text }, index) in options"
        :key="`custom-select-option-${index}`"
        :value="key"
        :selected="value === key"
        v-text="text"
      />
    </select>
  </div>
</template>

<script>
export default {
  name: 'CustomSelect',
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    icon: String,
    placeholder: String,
    color: {
      type: String,
      default: 'white'
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      rootClass: 'custom-select'
    }
  },
  methods: {
    emitInput(ev) {
      this.$emit('input', { name: this.name, value: ev.target.value })
    }
  }
}
</script>

<style>
.custom-select {
  display: flex;
  justify-content: flex-start;
  gap: 0.75rem;
  color: white;
  width: 100%;
}

.custom-select__icon {
  padding-top: 0.25rem;
}


 .custom-select .form-select {
  flex: 1;
  color: white;
}
</style>